module.exports = __webpack_public_path__ + "./daisy_eb4de17935b0c6edd42390e6be12f504.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/daisy.png
// module id = 458
// module chunks = 0